module.exports = __webpack_public_path__ + "static/media/org1.af8b8714.png";